import LogicFlow from '@logicflow/core';

// 统一计算 LogicFlow 画布尺寸，缺省时提供安全的降级大小
export const calculateCanvasSize = (container: HTMLElement) => {
  const containerRect = container.getBoundingClientRect();
  let width = container.offsetWidth || containerRect.width || 0;
  let height = container.offsetHeight || containerRect.height || 0;

  if (width === 0) width = 800;
  if (height === 0) height = 600;

  return { width, height };
};

interface AnchorOptions {
  forceRender?: boolean;
  logLabel?: string;
}

// 动态分组节点在多种交互下都需要强制显示锚点，该方法集中控制
export const ensureDynamicGroupAnchorsVisible = (
  lfInstance: LogicFlow | null,
  nodeId?: string,
  options?: AnchorOptions
) => {
  if (!lfInstance || !nodeId) return;
  const nodeModel = lfInstance.getNodeModelById(nodeId) as any;
  if (!nodeModel) return;
  nodeModel.setIsShowAnchor(true);
  if (options?.forceRender && typeof nodeModel.setAttributes === 'function') {
    nodeModel.setAttributes();
  }
  if (options?.logLabel) {
    console.log(options.logLabel, nodeId);
  }
};

interface DynamicGroupTextClickParams {
  lfInstance: LogicFlow | null;
  canvasElement: HTMLDivElement | null;
  event: MouseEvent;
  nodeId: string;
}

// 判断点击是否落在可拖动的动态分组文字区域，用于阻断默认节点逻辑
export const isDynamicGroupTextClick = ({
  lfInstance,
  canvasElement,
  event,
  nodeId,
}: DynamicGroupTextClickParams) => {
  if (!lfInstance || !canvasElement) return false;
  const nodeModel = lfInstance.getNodeModelById(nodeId) as any;
  if (!nodeModel || !nodeModel.textDraggable) {
    return false;
  }

  const canvasRect = canvasElement.getBoundingClientRect();
  const relativeX = event.clientX - canvasRect.left;
  const relativeY = event.clientY - canvasRect.top;
  const transform = lfInstance.getTransform() as any;
  const scale = transform?.SCALE_X || transform?.scale || 1;
  const translateX = transform?.TRANSLATE_X || transform?.translateX || 0;
  const translateY = transform?.TRANSLATE_Y || transform?.translateY || 0;
  const canvasX = (relativeX - translateX) / scale;
  const canvasY = (relativeY - translateY) / scale;

  return Boolean(nodeModel.isPointInTextArea?.(canvasX, canvasY));
};
